import { FC } from 'react';

import { ResponsiveLine } from '@nivo/line';

export interface BucketsKeyedByLabel {
  [label: string]: {
    [bucketName: string]: number;
  };
}

export const LineChart: FC<{
  height: number;
  colors?: string[];
  data: BucketsKeyedByLabel;
  margin?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
}> = ({ height, colors, data, margin: marginOverride = {} }) => {
  const margin = {
    top: 10,
    right: 20,
    bottom: 30,
    left: 40,
    ...marginOverride,
  };

  const transformedData = Object.entries(data).map(([label, buckets]) => {
    return {
      id: label,
      data: Object.entries(buckets).map(([bucketName, bucketValue]) => {
        return { x: bucketName, y: bucketValue };
      }),
    };
  });

  const maxValues = 5;
  const axisBottomValues = transformedData?.[0]?.data?.map((d: any) => d.x) ?? [];
  const modBy = Math.max(1, Math.ceil((axisBottomValues?.length ?? 1) / maxValues));

  const tickValues = axisBottomValues.filter((v: any, i: any) => {
    return i % modBy === 0;
  });

  return (
    <div style={{ height }}>
      <ResponsiveLine
        data={transformedData}
        margin={margin}
        xScale={{ type: 'point' }}
        colors={colors}
        yScale={{
          type: 'linear',
          min: 'auto',
          max: 'auto',
          stacked: true,
          reverse: false,
        }}
        yFormat=" >-.2f"
        curve="monotoneX"
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 0,
          tickPadding: 10,
          tickRotation: 0,
          tickValues,
          legend: '',
          legendOffset: 36,
          legendPosition: 'middle',
          truncateTickAt: 0,
        }}
        axisLeft={{
          tickValues: 5,
          tickSize: 0,
          tickPadding: 10,
          tickRotation: 0,
          legend: '',
          legendOffset: -40,
          legendPosition: 'middle',
          truncateTickAt: 0,
          format: (value: number) => (Number.isInteger(value) ? value : ''),
        }}
        enablePoints={false}
        enableGridX={false}
        pointSize={10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabel="data.yFormatted"
        pointLabelYOffset={-12}
        isInteractive={false}
        enableTouchCrosshair={true}
        useMesh={true}
        theme={{
          text: { fill: '#fff', fontFamily: 'var(--f7-font-family)' },
          grid: {
            line: {
              stroke: 'rgba(255,255,255,.05)', // ← your desired color
              strokeWidth: 1, // optional
            },
          },
        }}
        // legends={[
        //   {
        //     anchor: 'bottom-right',
        //     direction: 'column',
        //     justify: false,
        //     translateX: 100,
        //     translateY: 0,
        //     itemsSpacing: 0,
        //     itemDirection: 'left-to-right',
        //     itemWidth: 80,
        //     itemHeight: 20,
        //     itemOpacity: 0.75,
        //     symbolSize: 12,
        //     symbolShape: 'circle',
        //     symbolBorderColor: 'rgba(0, 0, 0, .5)',
        //     effects: [
        //       {
        //         on: 'hover',
        //         style: {
        //           itemBackground: 'rgba(0, 0, 0, .03)',
        //           itemOpacity: 1,
        //         },
        //       },
        //     ],
        //   },
        // ]}
      />
    </div>
  );
};
